import { type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const MinusSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => (
  <Icon size="S" aria-hidden={true} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z" />
    </svg>
  </Icon>
);

export default MinusSVG;
